module.exports = __webpack_public_path__ + "static/media/EHS-Employee-Handbook-Excel-Healthcare-Services-Ltd.c3d8c0e1.pdf";